<template>
    <main class="restrunt_list_main" id="restrunt_list_main">
        <div class="restrunt_list_main_top_line">
            <div class="container">
                <h1>Рестораны {{city.name}}</h1>
            </div>

        </div>
        <section class="section_a">
            <div class="container ">
                <aside class="order_crytery">
                    <div class="order_crytery_title">
                        <h3>Критерии</h3>
                        <button type="button" class="choice_toggle" id="restaurant_toggle"></button>
                    </div>
                    <div class="order_crytery_inner" id="restaurant_crytery_inner">
                        <div class="meals">
                            <h3>Блюда</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="(kitchen, id) in kitchens" :key="id">
                                    <input type="checkbox" v-model="filter.categories[id]" :value="id" name="choose">
                                    {{kitchen}}
                                    <span> </span>
                                </label>
                            </div>

                        </div>
                        <div class="min_amount">
                            <h3>Минимальная сумма заказа</h3>
                            <div class="range_value">
                                <p id="display_range_value_2">{{price}}</p>
                            </div>
                            <div class="change_range">
                                <input type="range" id="min_amount_range_2" :min="min" :max="max" :step="step" :value="price" name="min_amount_range">
                            </div>

                        </div>
                        <div class="ordering_criteria">
                            <h3>Критерии заказа</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="(method, id) in methods" :key="id">
                                    <input type="checkbox" v-model="filter.methods[id]" :value="id" name="choose">
                                    {{method}}
                                    <span> </span>
                                    <span v-if="id === 4" :class="[auth.user? 'login header-login logged' : 'login header-login']"><a style="color: #56d023;text-decoration: underline;margin-top: 0px;margin-right: 0px;"> только авторизованным гостям</a></span>
                                </label>

                            </div>

                        </div>

                    </div>
                </aside>
                <div class="rest_items">
                    <h3 class="rest_items_list_title">Рестораны {{city.name}}</h3>
                    <slot v-for="(restaurant, index) in restaurants">
                    <rest-block v-if="restaurants.length" :restaurant.sync="restaurant"  :auth.sync="auth" :city.sync="city"></rest-block>
                    <div class="item_rest_adv" :key="restaurant.id" v-if="(index+1)%5 === 0 && restaurants.length && restaurant.show" >
                        <h2 class="title">Получи 200 рублей за<br>
                            регистрацию на бонусный счет
                        </h2>
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/money.svg" alt="money">
                        <button class="green_btn">Получить</button>
                    </div>
                    </slot>
                  <!-- admitad.banner: y7crrldp58ec5b2d18f6cf21c29436 vodovoz -->
                  <!--a target="_blank" rel="nofollow" href="https://ad.admitad.com/g/y7crrldp58ec5b2d18f6cf21c29436/?i=4"><img width="600" height="90" border="0" src="https://ad.admitad.com/b/y7crrldp58ec5b2d18f6cf21c29436/" alt="vodovoz"/></a-->
                  <!-- /admitad.banner -->
                    <!-------Show more(button)----------->
                    <button style="display: none" type="button" class="menu_item_btn add">Показать еще<img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_list/add_more.svg" alt=""></button>
                </div>
            </div>
        </section>
        <section class="section_b">
            <div class="container">
                <div class="title">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
                    <h1>Круглосуточная доставка еды</h1>
                </div>

                <p>
                    Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.
                </p>
            </div>
        </section>
    </main>
</template>

<script>
import Vue from 'vue'
import axios from '@/router/http'
import restBlock from '@/components/restaurant'
export default {
  name: 'restaurants',
  props: ['city', 'auth'],
  components: {restBlock},
  data () {
    return {
      restaurants: [],
      kitchens: [],
      methods: [],
      max: 0,
      min: 0,
      step: 0,
      price: 0,
      filterWrap: 0,
      filter: {
        categories: {},
        methods: {}
      },
      title: 'все рестораны города ' + this.city.name
    }
  },
  metaInfo () {
    return {
      title: ' - рестораны города ' + this.city.name,
      meta: [
        { vmid: 'description', name: 'description', property: 'description', content: 'Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе ' + this.city.name + ' - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.' }
      ]
    }
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/restaurants-get?uid=' + this.auth.uid).then(response => {
        this.restaurants = response.data.restaurants
        this.kitchens = response.data.kitchens
        this.methods = response.data.methods
        this.max = response.data.max
        this.min = response.data.min
        this.step = response.data.step
        this.price = this.max
      })
    },
    reshow () {
      let categories = this.filter.categories
      let methods = this.filter.methods
      $.each(categories, (k, v) => {
        if (v === false) Vue.delete(categories, k)
      })
      $.each(methods, (k, v) => {
        if (v === false) Vue.delete(methods, k)
      })
      for (let restaurantId in this.restaurants) {
        let sc = 0
        let sm = 0
        let saa = 0
        if (Object.keys(categories).length) {
          $.each(categories, (k, v) => {
            if ($.inArray(k, Object.keys(this.restaurants[restaurantId].categories)) !== -1) sc = 1
          })
        } else sc = 1

        if (Object.keys(methods).length) {
          $.each(methods, (k, v) => {
            if ($.inArray(k, Object.keys(this.restaurants[restaurantId].methods)) !== -1) sm = 1
          })
        } else sm = 1
        if (parseInt(this.restaurants[restaurantId].minimal_amount) <= this.price) saa = 1
        if (sc === 1 && sm === 1 && saa === 1) this.restaurants[restaurantId].show = 1; else this.restaurants[restaurantId].show = 0
      }
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  mounted () {
    let $this = this
    $('#restaurant_toggle').on('click', function () {
      $('#restaurant_crytery_inner').toggleClass('active')
      $('.choice_toggle').toggleClass('active')
    })

    $('#min_amount_range').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })
    $('#min_amount_range_2').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })
  },
  watch: {
    'auth.city' (val) {
      this.initAjax()
    },
    'auth.setNewAdr' (val) {
      this.initAjax()
    },
    filter: {
      handler (newVal, oldVal) {
        this.reshow()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .rest_item:hover {
      box-shadow: 0px 4px 16px rgba(241, 126, 0, 0.5);
      transform: translate3d(0px, -5px, 5px);
      cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/pages/restaurants.vue